var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeftThin = function SvgArrowLeftThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Close Menu_big",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.474 4.84a.5.5 0 0 0-.357.15l-5.974 6.08a.5.5 0 0 0 0 .7l5.974 6.08a.5.5 0 0 0 .713-.7L8.2 11.42l5.63-5.73a.5.5 0 0 0-.356-.85z",
    "data-name": "Path 11603"
  })));
};
export default SvgArrowLeftThin;